<template>
	<!-- Digital Wallets Summary -->
	<!-- Enable this down the road when we're ready to adjust shipping options from the APM pay sheets -->
	<!-- v-if="!this.store.user.id" -->
	<div class="mt-4">
		<div class="w-full flex flex-col items-center">
			<!-- <div class="flex text-start text-base text-ihh-midnight-gray mb-4 w-full">Check out faster with:</div> -->
			<div class="flex flex-col items-center md:items-start w-full gap-y-2 max-w-[350px] md:max-w-[350px]">
				<!-- PayPal Row (Full Width on md+) -->
				<div class="w-80 md:w-full">
					<PayPalButton :layout="column" />
				</div>

				<!-- Other Payment Methods Row -->
				<div class="flex flex-col gap-y-2 md:flex-row md:justify-between w-80 md:w-full md:gap-x-2">
					<!-- Venmo Button -->
					<div v-if="showVenmo" class="w-full md:flex-1">
						<VenmoButton :isVenmoCheckout="true" @updateShowVenmo="handleVenmoAvailability" />
					</div>

					<!-- Google Pay Placeholder -->
					<!-- <div class="w-full md:flex-1">
						<button class="h-10 px-4 items-center w-full bg-black hover:opacity-90 text-white rounded font-medium text-base transition duration-200">
							<div class="flex w-full justify-center items-center gap-2">
								<img src="/images/Google__G__logo.svg" alt="" class="w-4 h-4" />
								<span>Pay</span>
							</div>
						</button>
					</div> -->

					<!-- Apple Pay -->
					<div class="w-full md:flex-1" :class="[!showApplePay ? 'hidden' : '']">
						<ApplePayButton @updateAvailability="handleAppleAvailability" />
					</div>

					<!-- Google Pay -->
					<!-- <div class="w-full md:flex-1" :class="[!showGooglePay ? 'hidden' : '']">
						<GooglePayButton @updateAvailability="handleGoogleAvailability" />
					</div> -->

					<!-- Apple Pay Placeholder -->
					<!-- <button class="h-10 px-4 items-center w-full bg-black hover:opacity-90 text-white rounded font-medium text-base transition duration-200">
						<div class="flex w-full justify-center items-center gap-2">
							<svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
								<path
									d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
								/>
							</svg>
							<span>Pay</span>
						</div>
					</button> -->
				</div>
			</div>
		</div>
	</div>
	<div class="flex items-center justify-between truncate w-full py-4">
		<div class="border-b border-solid border-ihh-gray/40 rounded-l-full flex-grow min-w-[1rem] md:min-w-[2rem] shrink-0" />
		<div class="text-xs md:text-sm text-ihh-midnight-gray mx-2 md:mx-4">OR</div>
		<div class="border-b border-solid border-ihh-gray/40 rounded-r-full flex-grow min-w-[1rem] md:min-w-[2rem] shrink-0" />
	</div>
</template>

<script>
import PayPalButton from './paypal-button.vue'
import VenmoButton from './venmo-button.vue'
import ApplePayButton from './apple-pay-button.vue'
import GooglePayButton from './google-pay-button.vue'

export default {
	name: 'DigitalWallets',
	inject: ['store', 'checkout'],
	components: { PayPalButton, VenmoButton, ApplePayButton, GooglePayButton },
	data() {
		return {
			windowWidth: window.innerWidth,
			showApplePay: true,
			showVenmo: true,
			showGooglePay: true,
		}
	},
	computed: {
		paypalLayout() {
			return this.windowWidth >= 768 ? 'row' : 'column'
		},
		hideWallets() {
			if ((this.checkout.giftCertificateAmount > 0 || this.checkout.storeCredit > 0) && this.checkout.remainingBalance - this.checkout.shippingTotal <= 0) {
				return true
			}
			return false
		},
	},
	methods: {
		updateWidth() {
			this.windowWidth = window.innerWidth
		},
		handleAppleAvailability(value) {
			this.showApplePay = value
		},
		handleVenmoAvailability(value) {
			this.showVenmo = value
		},
		handleGoogleAvailability(value) {
			this.showGooglePay = value
		},
	},
	mounted() {
		window.addEventListener('resize', this.updateWidth)
	},
	unmounted() {
		window.removeEventListener('resize', this.updateWidth)
	},
}
</script>

<style scoped></style>
